import React from "react";

const stepOneIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.625 2.25H6.375C3.715 2.25 2.25 3.715 2.25 6.375V17.625C2.25 20.285 3.715 21.75 6.375 21.75H17.625C20.285 21.75 21.75 20.285 21.75 17.625V6.375C21.75 3.715 20.285 2.25 17.625 2.25ZM17.25 20.25H6.75V19.87C6.75 19.037 7.00504 16.3199 10.29 16.3199H13.71C16.995 16.3199 17.25 19.037 17.25 19.87V20.25ZM20.25 17.625C20.25 19.031 19.787 19.817 18.75 20.111V19.87C18.75 17.54 17.43 14.8199 13.71 14.8199H10.29C6.57004 14.8199 5.25 17.541 5.25 19.87V20.111C4.213 19.817 3.75 19.03 3.75 17.625V6.375C3.75 4.535 4.535 3.75 6.375 3.75H17.625C19.465 3.75 20.25 4.535 20.25 6.375V17.625ZM12.0081 6.25C9.94106 6.25 8.25806 7.932 8.25806 10C8.25806 12.068 9.94106 13.75 12.0081 13.75C14.0751 13.75 15.7581 12.068 15.7581 10C15.7581 7.932 14.0751 6.25 12.0081 6.25ZM12.0081 12.25C10.7681 12.25 9.75806 11.241 9.75806 10C9.75806 8.759 10.7681 7.75 12.0081 7.75C13.2481 7.75 14.2581 8.759 14.2581 10C14.2581 11.241 13.2481 12.25 12.0081 12.25Z"
      fill="#888888"
    />
  </svg>
);

export default stepOneIcon;
